module.exports = __webpack_public_path__ + "img/293D21_ABC692_73B255_667C5C-256px.6fde4a2a.png";